/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssessmentResult } from './assessmentResult';


export interface AssessedCourseApiModel { 
    id: number;
    name: string;
    code: string;
    maxPeriod: number;
    result: AssessmentResult;
    timeIntervalLimit?: number | null;
    note?: string | null;
    capabilityDefinitionsId: number;
}
export namespace AssessedCourseApiModel {
}


